import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import _ from "lodash";
import {
	RaisedButton,
	FlatButton,
	Dialog,
	MenuItem,
	FloatingActionButton
} from "material-ui";
import SearchIcon from "material-ui/svg-icons/action/search";
import { TextField, SelectField } from "redux-form-material-ui";
import { reduxForm, Field, formValueSelector, getFormValues } from "redux-form";
import UtilPC from "../../../common/UtilPC";
import Util, { ERROR, SUCCESS, WARNING } from "../../../common/Util";
import {
	required,
	requiredNoUnderscore,
	onKeyPressNumberAndCommaOnly
} from "../../../common/validaciones";
import InputMask from "../../../components/InputMask/InputMask";
import { actionGetEmpresaByCuit } from "../../../actions/EmpresaActions";
import ImageSelector from "../../../components/ImageSelector/ImageSelector";
import {
	actionUploadFile,
	actionDeleteImage
} from "../../../actions/MediaActions";
import { actionGetContributions } from "../../../actions/AfiliadoActions";
import {
	actionCreateSalary,
	actionUpdateSalary
} from "../../../actions/SalaryActions";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE
} from "../../../actions/ActionConstants";

class AddSalaryDialogForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			years: this.getYears(),
			companyFound: null
		};
	}

	componentWillMount() {
		this.setState({ months: this.getMonths(moment().year()) });
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.open &&
			!this.props.open &&
			nextProps.modeCRU === MODE_CRU_UPDATE
		) {
			nextProps.salary.idCompany
				? this.setState({
						companyFound: true,
						months: this.getMonths(nextProps.salary.year)
				  })
				: this.setState({
						companyFound: false,
						months: this.getMonths(nextProps.salary.year)
				  });
			this.props.initialize({
				...nextProps.salary,
				companyCuit: nextProps.salary.companyCuit.toString()
			});
		}
		if (nextProps.company) {
			if (this.props.formValues.idCompany !== nextProps.company.id) {
				this.props.change("idCompany", nextProps.company.id);
				this.props.change("companyName", nextProps.company.name);
				this.setState({ companyFound: true });
			}
		}
	}

	onClose = () => {
		this.props.initialize({ year: moment().year() });
		this.setState({ companyFound: null });
		this.props.onRequestClose();
	};

	onChangeYear = (event, key) => {
		this.setState({ months: this.getMonths(key) });
	};

	getMonths(year) {
		let months = UtilPC.menuItemsMonths();
		if (year === moment().year()) {
			this.props.change("month", null);
			return _.slice(months, 0, moment().month());
		}
		return months;
	}

	getYears() {
		let years = [];
		let currentYear = moment().year();
		for (let i = currentYear; i >= 2013; i--) {
			years.push(<MenuItem value={i} key={i} primaryText={i} />);
		}
		return years;
	}

	onClickSearch = () => {
		this.props.actionGetEmpresaByCuit(
			this.props.formValues.companyCuit,
			this.callbackOnClickSearch
		);
	};

	callbackOnClickSearch = status => {
		if (status === ERROR) {
			this.setState({ companyFound: false });
			this.props.change("idCompany", null);
		}
	};

	onSubmit(formValues) {
		if (formValues.photoURL) {
			if (typeof formValues.photoURL === "object") {
				if (this.props.modeCRU === MODE_CRU_UPDATE)
					this.props.actionDeleteImage(
						formValues.photoPath,
						this.props.firebaseToken,
						this.executeActionUploadFile.bind(this)
					);
				else this.executeActionUploadFile();
			} else {
				let values = this.props.allFormValues;
				values.amount = Number(("" + values.amount).replace(/,/, "."));
				this.props.actionUpdateSalary(values, this.returnAction.bind(this));
			}
		} else Util.showNoty(WARNING, "Debe seleccionar una imagen");
	}

	executeActionUploadFile() {
		let firebasePath = "afiliado/haber";
		let type = "image";
		this.props.actionUploadFile(
			this.props.allFormValues.photoURL,
			firebasePath,
			type,
			this.props.firebaseToken,
			this.returnGoToUploadAddSalary.bind(this)
		);
	}

	returnGoToUploadAddSalary(URLPhoto, path) {
		let values = this.props.allFormValues;
		values.photoURL = URLPhoto;
		values.photoPath = path;
		values.amount = Number(("" + values.amount).replace(/,/, "."));
		if (this.props.modeCRU === MODE_CRU_CREATE)
			this.props.actionCreateSalary(values, this.returnAction.bind(this));
		else if (this.props.modeCRU === MODE_CRU_UPDATE)
			this.props.actionUpdateSalary(values, this.returnAction.bind(this));
	}

	returnAction(status) {
		if (status === SUCCESS) {
			Util.showNoty(SUCCESS, "Salario guardado exitosamente");
			this.props.actionGetContributions(this.props.formValues.affiliateNumber);
			this.onClose();
		}
	}

	render() {
		return (
			<Dialog
				style={{ zIndex: 15 }}
				title="Cargar Haberes"
				modal={false}
				actions={[
					<FlatButton
						style={{ marginRight: 5 }}
						label="Cancelar"
						onClick={this.onClose}
					/>,
					<RaisedButton
						label="Aceptar"
						primary
						onClick={this.props.handleSubmit(this.onSubmit.bind(this))}
						disabled={this.state.companyFound === null}
					/>
				]}
				autoScrollBodyContent
				open={this.props.open}
				onRequestClose={this.onClose}
			>
				<form ref="form">
					<div
						style={{
							display: "flex",
							flexDirection: "row"
						}}
						className="align-center"
					>
						<Field
							name="amount"
							component={TextField}
							floatingLabelText="Salario"
							format={Util.formatPesos}
							parse={Util.parsePesos}
							onKeyPress={onKeyPressNumberAndCommaOnly}
							validate={required}
							style={{ width: 120 }}
						/>
						<Field
							name="year"
							component={SelectField}
							floatingLabelText="Año"
							onChange={this.onChangeYear}
							validate={required}
							style={{ marginLeft: 25, marginRight: 25, width: 92 }}
						>
							{this.state.years}
						</Field>
						<Field
							name="month"
							component={SelectField}
							floatingLabelText="Mes"
							validate={required}
							style={{ width: 140 }}
						>
							{this.state.months}
						</Field>
					</div>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							height: 278
						}}
					>
						<Field
							name="companyCuit"
							component={InputMask}
							style={{ marginRight: 10, width: 120 }}
							floatingLabelText="CUIT"
							mask={[
								/\d/,
								/\d/,
								"-",
								/\d/,
								/\d/,
								/\d/,
								/\d/,
								/\d/,
								/\d/,
								/\d/,
								/\d/,
								"-",
								/\d/
							]}
							onChange={() => this.setState({ companyFound: null })}
							parse={Util.formatCuitToNumber}
							validate={requiredNoUnderscore}
						/>
						<FloatingActionButton
							style={{ marginTop: 31, marginRight: 16 }}
							onClick={this.onClickSearch}
							zDepth={0}
						>
							<SearchIcon />
						</FloatingActionButton>
						<Field
							name="companyName"
							component={TextField}
							floatingLabelText="Nombre Empresa"
							validate={this.state.companyFound === false ? required : null}
							disabled={
								this.state.companyFound === null ||
								this.state.companyFound === true
							}
						/>
						<div style={{ marginTop: -39, marginLeft: 10, maxWidth: 250 }}>
							<ImageSelector
								fieldName="photoURL"
								label="Seleccionar imagen"
								// noPreview
								fileSize={300000}
								imagePreviewUrl={
									this.props.modeCRU === MODE_CRU_UPDATE &&
									this.props.salary.photoURL
										? this.props.salary.photoURL
										: ""
								}
							/>
						</div>
					</div>
				</form>
			</Dialog>
		);
	}
}

function mapStateToProps(store) {
	const selector = formValueSelector("AddSalaryDialogForm");
	return {
		company: store.empresa.empresa,
		formValues: selector(store, "idCompany", "companyCuit", "affiliateNumber"),
		allFormValues: getFormValues("AddSalaryDialogForm")(store),
		firebaseToken: store.app.firebaseToken,
		modeCRU: store.salary.modeCRU,
		salary: store.salary.salary,
		loading: store.app.loading
	};
}

export default reduxForm({
	form: "AddSalaryDialogForm",
	initialValues: { year: moment().year() }
})(
	connect(
		mapStateToProps,
		{
			actionGetEmpresaByCuit,
			actionUploadFile,
			actionCreateSalary,
			actionUpdateSalary,
			actionGetContributions,
			actionDeleteImage
		}
	)(AddSalaryDialogForm)
);



// WEBPACK FOOTER //
// ./src/screens/Afiliado/Tabs/AddSalaryDialogForm.js